import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "oio-action-item",
  "data-invisible": "false"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OioButton = _resolveComponent("OioButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OioButton, {
      type: "primary",
      onClick: _ctx.handleExport
    }, {
      default: _withCtx(() => [
        _createTextVNode("导出")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}